import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";

interface Props {
  onClose: () => void;
}

function MobileEmptyCartPopup({ onClose }: Props) {
  useBodyScrollLock();
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div
      className="mobile-bottom-popup-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="mobile-bottom-popup mobile-bottom-popup--animate">
        <div className="d-flex justify-content-end px-3 pt-3">
          <button className="btn-close" onClick={onClose} aria-label={t("common.close")} />
        </div>
        <div className="text-center px-4 pb-4">
          <i className="bi bi-cart-x" style={{ fontSize: "3rem", color: "#ccc" }}></i>
          <p className="mt-2 fw-semibold">{t("cart.empty")}</p>
          <button
            className="btn btn-danger rounded-pill px-4 py-2 fw-semibold"
            onClick={() => { onClose(); navigate("/restaurants"); }}
          >
            <i className="bi bi-shop me-2"></i>
            {t("dashboard.promoButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileEmptyCartPopup;
